<template>
<!-- 입과 불가자 등록하기 팝업 -->
<transition name="modal" appear>
    <div class="modal modal-overlay">
        <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content">
                <div class="modal-body">
                    <div>
                        <p class="bold dp-inblock h-30px font-23">{{programName}} <br> 입과 불가자 등록하기</p>
                        <a class="pointer float-right layer-close ml-30" @click="$emit('close')" data-dismiss="modal" aria-label="Close">
                            <img src="../../assets/img/close.png" alt="close" class="close-btn">
                        </a>
                        <p class="font-13 pt-10">
                            - 반드시 엑셀 양식을 다운로드 후, 등록해 주시기 바랍니다. <br>
                            - 등록 후 입과 불가자 버튼을 클릭하여 확인할 수 있습니다.
                        </p>

                        <div class="mt-30">
                            <a style="width: 120px; float: right" class="txt-green font-13 txt-right dp-block pb-10 pointer" @click="exportTempExcel()"><i class="fas fa-download"></i> 엑셀양식 다운로드</a>
                            <div class="filebox w-100per">
                                <input type="file" id="file" ref="file" accept=".csv,.xlsx,.xlsm,.xlsb,.xltx,.xltxm,.xls,.xlt,.xml,.xlam" @change="selectFile($event)">
                                <input class="upload-name" :value="selectedFileName" placeholder="파일을 업로드 해주세요">
                                <label name="fileUpload" @click="$refs.file.click()">업로드</label>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer txt-center">
                    <a class="pointer admin-btn-default btn ml-05" @click="upload()">확인</a>
                </div>
            </div>
        </div>
        <load-modal v-if="isLoadModalOpened" :parentIdx="parentIdx" @applyProgram="applyProgram" @close="closeModal"></load-modal>
    </div>
</transition>
</template>

<script>
import FileSaver from 'file-saver'
import LoadModal from '@/components/reg/enroll/loadModal.vue'
export default {
    props: ['parentIdx'],
    components: {
        LoadModal,
    },
    data: () => ({
        status: 'none',
        selectedFiles: '', // 엑셀 업로드 파일 전체 데이터
        completeFile: '', // 엑셀 업로드 파일 파라미터 데이터
        selectedFileName: '', // 수료증 첨부파일 이름
        pageIdx: 6, // 수강신청 페이지 idx
        programIdx: 31, // 프로그램 idx
        programName: '',
        isLoadModalOpened: false
    }),

    beforeDestroy() {
        console.log('모달 초기화')
    },

    mounted() {
        if (sessionStorage.getItem('programName')) {
            this.programName = sessionStorage.getItem('programName')
        }

        this.pageIdx = this.parentIdx
        this.isLoadModalOpened = true
    },

    methods: {
        applyProgram(idx) {
            this.programIdx = idx
            this.isLoadModalOpened = false
        },

        closeModal() {
            this.isLoadModalOpened = false
        },

        exportTempExcel() {
            window.open('https://kr.object.ncloudstorage.com/itmsugang/excel/sugang_ban_excel_template.xlsx')
            // var params = {
            //     fileName: 'sugang_ban_excel_template.xlsx',
            //     folderName: 'excel'
            // }

            // this.axios.get(this.axios.root + this.axios.port + '/storage/download-object', {
            //     params: params
            // }, {
            //     responseType: 'arraybuffer'
            // }).then(res => {
            //     FileSaver.saveAs(new Blob([res.data]), "sugang_ban_excel_template.xlsx")
            // }).catch(err => {
            //     console.log(err)
            //     alert(err)
            // })
        },

        upload() {
            if (this.completeFile === '') {
                alert('엑셀 파일을 업로드 해주세요.')
                return false
            } else {
                let formData = new FormData()
                formData.append('file', this.completeFile)
                formData.append('pageIdx', this.pageIdx)
                formData.append('programIdx', this.programIdx)

                let headers = {
                    'Content-Type': 'multipart/form-data',
                    'Access-Control-Allow-Origin': 'multipart/form-data'
                }

                this.axios.post(this.axios.root + this.axios.port + '/excel/upload-ban', formData, headers)
                    .then(res => {
                        console.log('res', res)
                        alert('업로드 되었습니다.')
                        this.$emit('close')
                        // if (res.data.err === 0) {
                        //     alert('업로드 되었습니다.')
                        // } else {
                        //     alert(res.data.result)
                        // }
                    }).catch(err => {
                        console.log(err)
                        alert(err)
                        this.$emit('close')
                    })
            }

        },
        selectFile(event) {
            console.log('데이터 확인')
            this.selectedFiles = this.$refs.file.files;
            var allowFormat = ['csv', 'xlsx', 'xlsm', 'xlsb', 'xltx', 'xltxm', 'xls', 'xlt', 'xml', 'xlam']
            var checked = false
            for (var item of allowFormat) {
                if (this.selectedFiles[0].name.includes(item)) {
                    checked = true
                    break
                } else {
                    continue
                }
            }
            if (checked) {
                let file = event.target.files[0]

                if (event.target.files[0].size > 1048576) {
                    alert('1MB 이하만 업로드 가능합니다.')
                    this.$refs.file.value = ''
                    this.selectedFiles = ''
                    return false
                }

                this.completeFile = event.target.files[0]
                this.selectedFileName = event.target.files[0].name
                let formData = new FormData()
                formData.append('file', file)
                formData.append('pageIdx', file)
                formData.append('file', file)

                this.$refs.file.value = ''
            } else {
                alert('파일 포맷은 엑셀 파일 형식만 가능합니다.')
                this.$refs.file.value = ''
                this.selectedFiles = ''
                return false
            }
        },
    }
}
</script>

<style lang="scss" scoped>
.modal {
    &.modal-overlay {
        display: flex;
        align-items: center;
        justify-content: center;
        position: fixed;
        z-index: 30;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.5);
    }

    &-window {
        background: #fff;
        border-radius: 4px;
        overflow: hidden;
    }

    &-content {
        padding: 10px 20px;
    }

    &-footer {
        background: #fff;
        padding: 10px;
        text-align: right;
    }
}

.modal-enter-active,
.modal-leave-active {
    transition: opacity 0.4s;

    .modal-window {
        transition: opacity 0.4s, transform 0.4s;
    }
}

.modal-leave-active {
    transition: opacity 0.6s ease 0.4s;
}

.modal-enter,
.modal-leave-to {
    opacity: 0;

    .modal-window {
        opacity: 0;
        transform: translateY(-20px);
    }
}
</style>
